<template>
  <FontAwesomeIcon icon="question-circle" size="lg" />
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
</script>
